LocationController.$inject = ['$rootScope', 'LocationService', '$stateParams', 'AppService', '$uibModal', '$state', '$transitions']

export default function LocationController($rootScope, LocationService, $stateParams, AppService, $uibModal, $state, $transitions) {
  var vm = this

  function saveSelection() {
    if (window.getSelection) {
      sel = window.getSelection()
      if (sel.getRangeAt && sel.rangeCount) {
        var ranges = []
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          ranges.push(sel.getRangeAt(i))
        }
        return ranges
      }
    } else if (document.selection && document.selection.createRange) {
      return document.selection.createRange()
    }
    return null
  }

  var copy
  $rootScope.$watch('profile.id', profileId => {
    if (profileId !== undefined) {
      LocationService.getLocation(profileId, $stateParams.slug).then(res => {
        vm.location = res.data
        copy = angular.copy(vm.location)
      })
    }
  })

  vm.insertLink = function() {
    AppService.savedSel = saveSelection()

    $uibModal.open({
      controller: 'ModalLinkController',
      controllerAs: 'modalLink',
      template: require('../../app/link-modal-new.html')
    }).result.then(angular.noop, angular.noop)
  }
  vm.setPromoted = function() {
    vm.location.isPromoted = !vm.location.isPromoted
  }
  vm.setPublished = function() {
    vm.location.isPublished = !vm.location.isPublished
  }
  vm.delete = function() {
    vm.confirmDelete = true
  }
  vm.doDelete = function() {
    vm.hideAlert('confirmDelete')
    LocationService.deleteLocation(vm.location).then(() => $state.go('shell.locations'))
  }
  vm.hideAlert = function(alert) {
    vm[alert] = false
  }
  $transitions.onBefore({}, () => {
    if (!angular.equals(vm.location, copy)) return LocationService.putLocation(vm.location)
  }, {invokeLimit: 1})
}